<template>
  <form @submit.prevent="lauchFormSubmitted" ref="form">
    <slot name="additionnalFieldsTop"></slot>
    <div
      v-for="(field, i) in fields"
      :key="i"
      :class="[inputContainerClass, field.class || '']"
      :style="[!fieldsDisplayed[i] ? { display: 'none' } : {}]"
    >
      <InputComponent
        v-if="fieldsDisplayed[i]"
        v-model="filledFields[field.propertyName]"
        :label="field.label || ''"
        :placeHolder="field.placeHolder || ''"
        :alreadyExistPlaceHolder="field.alreadyExistPlaceHolder || ''"
        :type="field.type || 'text'"
        :required="!!field.required"
        :options="
          field.formatOptionsDisplay && field.options
            ? field.options.map(field.formatOptionsDisplay)
            : field.options || []
        "
        :selectInputDisplays="
          field.formatOptionInputDisplay && field.options
            ? field.options.map(field.formatOptionInputDisplay)
            : field.options || []
        "
        :validate="
          data => {
            if (!field.validate) return ''
            return field.validate(data, filledFields)
          }
        "
        :init="
          reloadingFunction => {
            reloadInputContentFunctions[i] = reloadingFunction
          }
        "
        @input="
          () => {
            onFieldChanged(field.propertyName, i)
          }
        "
        :value="filledFields[field.propertyName]"
        v-bind="{
          ...(field.inputProps || {}),
          ...(field.inputPropsComputed
            ? field.inputPropsComputed(filledFields) || {}
            : {}),
        }"
      ></InputComponent>
    </div>
    <button ref="internalSubmitButton" type="submit" class="hidden"></button>
    <slot name="submitButton">
      <button
        class="buttonComponent"
        type="submit"
        fullWidth
        :loading="loading"
        :rounded="false"
      >
        <slot name="submitButtonText"></slot>
      </button>
    </slot>
    <slot name="fieldsEnd"></slot>
  </form>
</template>

<script>
// import { MetaUtils } from "@/assets/js/utils/meta";
import InputComponent from './InputComponent.vue'

export default {
  name: 'FormComponent',
  components: { InputComponent },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: '',
    },
    fields: {
      type: Array,
      default: () => {
        return []
      },
    },
    onFormSubmited: {
      type: Function,
      default: data => {},
    },
    init: {
      type: Function,
      default: (submit, getData, resetInputsDefault) => {},
    },
    inputContainerClass: {
      type: String,
      default: '',
    },
    rightSectionPictureSrc: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:value', 'update:modelValue', 'fieldChanged', 'formSubmited'],
  data() {
    return {
      // email: "admin@1xpay.co",
      // password: "WhAxTA3U5GnN3l7WoF89EcCKgBBji",
      filledFields: {},
      reloadInputContentFunctions: [],
      fieldsDisplayed: [],
    }
  },
  mounted() {
    this.setDefaultFields()
    this.updateModelValue()
    setTimeout(this.setDefaultFields, 500)
    this.init(
      this.internalSubmitForm,
      this.getFormResponseData,
      this.setDefaultFields,
    )
  },
  methods: {
    setDefaultFields(forceDefaultValues = false) {
      if (!Array.isArray(this.fields)) return
      const newFilledFields = {}
      this.fields.forEach(field => {
        if (forceDefaultValues) {
          newFilledFields[field.propertyName] = field.defaultValue || ''
          return
        }
        if (typeof this.filledFields[field.propertyName] == 'boolean') {
          newFilledFields[field.propertyName] =
            this.filledFields[field.propertyName]
          return
        }
        if (typeof this.filledFields[field.propertyName] == 'number') {
          newFilledFields[field.propertyName] =
            this.filledFields[field.propertyName]
          return
        }
        if (typeof field.defaultValue == 'boolean') {
          newFilledFields[field.propertyName] = field.defaultValue
          return
        }
        if (typeof field.defaultValue == 'number') {
          newFilledFields[field.propertyName] = field.defaultValue
          return
        }
        if (field.type == 'toggle') {
          newFilledFields[field.propertyName] = false
          return
        }
        newFilledFields[field.propertyName] =
          this.filledFields[field.propertyName] || field.defaultValue || ''
      })
      this.filledFields = newFilledFields
      this.reloadInputContent()
    },
    setFieldValue(fieldId, value) {
      if (!Object.hasOwn(this.filledFields, fieldId)) return
      this.filledFields[fieldId] = value
      this.reloadInputContent()
    },
    updateModelValue() {
      const newFilledFields = {}
      this.fields.forEach(field => {
        newFilledFields[field.propertyName] =
          this.filledFields[field.propertyName] || field.defaultValue || ''
      })
      this.filledFields = newFilledFields
      this.reloadInputContent()
    },
    submit() {
      this.reloadInputContent()
      this.internalSubmitForm()
    },
    internalSubmitForm() {
      if (!this.$refs.internalSubmitButton) return
      this.$refs.internalSubmitButton.click()
    },
    reloadInputContent() {
      this.reloadInputContentFunctions.forEach(reloadingFunction => {
        reloadingFunction()
      })
      // this.$forceUpdate()
    },
    refreshDisplayedFields() {
      const fieldsDisplayed = []
      this.fields.forEach((field, index) => {
        if (!field.showFieldIf) {
          fieldsDisplayed[index] = true
          return
        }
        fieldsDisplayed[index] = field.showFieldIf(this.filledFields, this.getFormResponseData())
      })
      this.fieldsDisplayed = fieldsDisplayed
    },
    onFieldChanged(fieldId, position) {
      this.refreshDisplayedFields()
      const currentData = this.getFormResponseData()
      this.$emit('fieldChanged', currentData, fieldId)
      if (this.fields[position].onChanged)
        this.fields[position].onChanged(currentData[fieldId], currentData)
    },
    lauchFormSubmitted() {
      const responseData = this.getFormResponseData()
      // this.onFormSubmited(responseData)
      this.$emit('formSubmited', responseData)
    },
    getFormResponseData() {
      const filledFieldsToSend = {}
      Object.keys(this.filledFields).forEach((propertyName, index) => {
        const value = this.filledFields[propertyName]
        const sourceField = this.fields.find(field => {
          return field.propertyName == propertyName
        })
        if (!sourceField?.formatOptionsDisplay) {
          filledFieldsToSend[propertyName] = value
          return
        }
        const sourceOptions = sourceField.options
        const displayOptions = sourceField.options.map(
          sourceField.formatOptionsDisplay,
        )
        const selectedOptionId = displayOptions.indexOf(value)
        filledFieldsToSend[propertyName] = sourceOptions[selectedOptionId]
      })
      const dataToSend = JSON.parse(JSON.stringify(filledFieldsToSend))
      return dataToSend
    },
  },
  computed: {
    fieldsData() {
      return JSON.parse(JSON.stringify(this.filledFields))
    },
  },
  watch: {
    fields: {
      handler() {
        // this.setDefaultFields()
      },
      immediate: true,
      deep: true,
    },
    filledFields: {
      handler() {
        this.refreshDisplayedFields()
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
